import React from 'react';

const NeedsReviewBanner = ({ total }) => {
  if (!total) return null;
  return (
    <div className="mx-3 mt-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-1.5 text-xs font-medium text-amber-800 dark:border-amber-500/50 dark:bg-amber-900/20 dark:text-amber-200">
      {total} new product{total > 1 ? 's' : ''} from Square need
      {total > 1 ? '' : 's'} review
    </div>
  );
};

export default NeedsReviewBanner;
